module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_10.df6a9417.pdf";